import WaitingRoom from '@/components/Student/WaitingRoom'

const WaitingRoomScreen = () => {
  return <WaitingRoom />
}

export default WaitingRoomScreen
